// New version src/Common/controls/checkbox/checkbox.component.ts CommonCheckboxComponent
// Old version src/CaseDotStar.ServicePackages.Frontend.Common/scripts/common/controls/ctrl_checkbox_directive.js CtrlCheckbox

import {
	Component,
	EventEmitter,
	Input,
	Output,
	forwardRef,
	ChangeDetectionStrategy,
	Injector,
	SecurityContext
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonControlComponent } from '../control/control.component';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'common-checkbox',
	templateUrl: './checkbox.component.pug',
	changeDetection: ChangeDetectionStrategy.OnPush,
	styleUrls: [
		'../control/control.component.sass',
		'./checkbox.component.sass',
	],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => CommonCheckboxComponent),
			multi: true,
		},
	],
})
export class CommonCheckboxComponent extends CommonControlComponent {
	@Input() model: boolean;
	@Output() modelChange = new EventEmitter<boolean>();

	@Input() label: string;
	@Input() labelClasses: string;
	@Input() checkboxId: string;
	@Input() indeterminate: boolean;
	@Input() isDescriptionShow: boolean;
	@Input() descriptionValue: string;

	@Output() changeEvent = new EventEmitter<boolean>();

	idKey = 'checkbox_';

	constructor (
		protected injector: Injector,
		private domSanitize: DomSanitizer
		) {
		super(injector);
	}

	getIndeterminate (): boolean {
		return !this.model && this.indeterminate;
	}

	onChangeCheckbox (value: boolean) {
		const oldValue = this.model;
		this.model = value;

		if (oldValue !== value) {
			this.modelChange.emit(value);
			this.emitOnChange(value);
		}
	}

	getSanitizeLabel (): string {
		return this.domSanitize.sanitize(SecurityContext.HTML, this.label) ?? '';
	}

}
